import { render } from "./Waterfall.vue?vue&type=template&id=893bdd2c"
import script from "./Waterfall.vue?vue&type=script&lang=js"
export * from "./Waterfall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__